import * as React from 'react';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { Check } from 'lucide-react';

import { cn } from 'src/lib/utils';

const Checkbox = React.forwardRef(({ className, variant = 'default', ...props }, ref) => {
  const isSuccess = variant === 'success';
  return (
    <CheckboxPrimitive.Root
      ref={ref}
      className={cn(
        'peer h-4 w-4 shrink-0 rounded-sm border ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
        isSuccess
          ? 'border-gray-300 data-[state=checked]:bg-ah-status-success-checkbox data-[state=checked]:border-ah-status-success-checkbox data-[state=checked]:text-white'
          : 'border-ah-brand-primary-form data-[state=checked]:bg-ah-brand-primary-form data-[state=checked]:border-ah-brand-primary-form data-[state=checked]:text-primary-foreground',
        className
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        className={cn(
          'flex items-center justify-center',
          isSuccess ? 'text-white' : 'text-primary-foreground'
        )}
      >
        <Check className="h-4 w-4" />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
});
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
